import {Divider, Grid} from 'semantic-ui-react';

export default function FooterGridSpacer() {
  return (
    <Grid.Row>
      <Grid.Column>
        <Divider hidden/>
        <Divider hidden/>
      </Grid.Column>
    </Grid.Row>
  );
}